import { NgModule } from '@angular/core';
import { MatChipsModule, MatDatepickerModule, MatIconModule, MatListModule, MatNativeDateModule } from '@angular/material';
import { IonicPageModule } from 'ionic-angular';
import { ComponentsModule } from '../../components/components.module';
import { TimesheetService } from '../timesheets/providers/timesheet.service';
import { WeekStatusPage } from './week-status';
import { WeekStatusService } from './week-status.service';

@NgModule({
  declarations: [
    WeekStatusPage,
  ],
  imports: [
    IonicPageModule.forChild(WeekStatusPage),
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    MatListModule,
    MatChipsModule,
    ComponentsModule
  ],
  providers: [ WeekStatusService, TimesheetService ]
})
export class WeekStatusPageModule {}



// WEBPACK FOOTER //
// ./src/pages/week-status/week-status.module.ts